import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HomePolicy } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface PutPolicyParams extends DefaultHttpHeaders {
  /** Numerical reference that MAPFRE assigns to each insurance contract to identify it */
  policyId: string;
  /** Identifier of the company who owns the final contract */
  companyId?: string;
}

@Injectable()
export class PutPolicyService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Modify homePolicy
   * Modify homePolicy
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Policy/putHomePolicy
   */
  putPolicy(body: HomePolicy, params: PutPolicyParams): Observable<HomePolicy> {
    const pathParams = {
      policyId: params.policyId,
    };
    const queryParams = {
      companyId: params.companyId,
    };

    return this.put<HomePolicy, HomePolicy>({
      suffix: `/home/policy/${pathParams.policyId}`,
      body,
      queryParams,
      authenticationType: 'jwt',
    });
  }
}
